const host = location.host;

export default {
  DEV: import.meta.env.DEV,
  CDN: import.meta.env.VITE_CDN,
  API_ENDPOINT: import.meta.env.VITE_API_ENDPOINT,
  basePath: host.indexOf('localhost') > -1 ? '' : '/',
};
